export enum Environments {
	DEV = 'dev',
	CI = 'ci',
	QA = 'qa',
	AT = 'at',
	TR = 'tr',
	COLD = 'cd',
	PROD = 'pd'
}
